module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"rules":{"service_uri":{"require":"Please input domain","length":"Length should be minimum {count} symbols"}}},"ua":{"rules":{"service_uri":{"require":"Будь-ласка введіть домен","length":"Мае бути не меньше {count} символів"}}},"ru":{"rules":{"service_uri":{"require":"Пожалуйста введитеь домен","length":"Должно быть не меньш {count} символов"}}}}')
  delete Component.options._Ctor
}
